<template>
  <div v-show="!homeScreenStatus && !exerciseCompleted && !gameCompleted" class="game">
    <img class="foreground" src="@/assets/practices/pet_life/foreground.svg" alt="foreground" />
    <div class="bar">
      <p class="bar__points">Points: {{ playerScore }}</p>
      <div class="bar__lives">
        <ul>
          <li v-for="life in currentLives" :key="life">
            <img class="life" src="@/assets/practices/pet_life/life.svg" alt="life" />
          </li>
          <li v-for="life in maxLives - currentLives" :key="life + 10">
            <img class="life" src="@/assets/practices/pet_life/life_stroke.svg" alt="life_stroke" />
          </li>
        </ul>
      </div>
    </div>
    <div class="main">
      <div v-show="!explanationStatus" class="main__question">
        <p>{{ fiveExercises[currentExercise].question }}</p>
      </div>
      <div :class="{ feedback__correct: true, rise: answer === true }">
        <div id="orange-cat-game"></div>
        <div id="platform-correct"></div>
      </div>
      <div :class="{ feedback__incorrect: true, rise: answer === false }">
        <div id="black-cat-game"></div>
        <div id="platform-incorrect"></div>
      </div>
    </div>
    <div v-show="explanationStatus" class="explanation">
      <p>{{ fiveExercises[currentExercise].explanation }}</p>
    </div>
    <div class="bar-bottom">
      <span class="button--left"></span>
      <div :key="render" class="buttons--center">
        <Button
          :number="fiveExercises[currentExercise].options[0].number"
          :answer="fiveExercises[currentExercise].options[0].answer"
          @clicked="onClickChild"
        />
        <Button
          :number="fiveExercises[currentExercise].options[1].number"
          :answer="fiveExercises[currentExercise].options[1].answer"
          @clicked="onClickChild"
        />
        <Button
          :number="fiveExercises[currentExercise].options[2].number"
          :answer="fiveExercises[currentExercise].options[2].answer"
          @clicked="onClickChild"
        />
      </div>
      <div class="button--right">
        <div class="button--right--top" ontouchstart @click="clickContinue">
          <p class="button--right--text">Next</p>
          <img :src="require(`@/assets/practices/pet_life/button_next_top_${buttonStatus}.svg`)" alt="button_top" />
        </div>
        <img
          class="button--right--bottom"
          :src="require(`@/assets/practices/pet_life/button_next_bottom_${buttonStatus}.svg`)"
          alt="button_bottom"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import { Howl } from 'howler';
import lottie from 'lottie-web/build/player/lottie';
import exercises from '@/assets/practices/data/pet_life/exercises.json';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Game',
  components: {
    Button: () => import('@/components/practices/pet_life/Button.vue'),
  },
  data: () => ({
    exercises,
    fiveExercises: [],
    render: 0,
    buttonStatus: 'inactive',
    answer: null,
  }),
  computed: {
    ...mapGetters({
      correctStatus: 'petLife/correctStatus',
      currentExercise: 'petLife/currentExercise',
      currentLives: 'petLife/currentLives',
      exerciseCompleted: 'petLife/exerciseCompleted',
      explanationStatus: 'petLife/explanationStatus',
      gameCompleted: 'petLife/gameCompleted',
      homeScreenStatus: 'petLife/homeScreenStatus',
      maxLives: 'petLife/maxLives',
      playerScore: 'petLife/playerScore',
    }),
  },

  created() {
    this.fiveExercises = this.getRandom(exercises, 5);
  },
  mounted() {
    const orangeCatGameAnimation = lottie.loadAnimation({
      container: document.getElementById('orange-cat-game'),
      renderer: 'svg',
      loop: true,
      path: '/assets/practices/pet_life/animations/pet_life_cat_orange.json',
    });
    const blackCatGameAnimation = lottie.loadAnimation({
      container: document.getElementById('black-cat-game'),
      renderer: 'svg',
      loop: true,
      path: '/assets/practices/pet_life/animations/pet_life_cat_black.json',
    });
    const platformCorrectAnimation = lottie.loadAnimation({
      container: document.getElementById('platform-correct'),
      renderer: 'svg',
      loop: true,
      path: '/assets/practices/pet_life/animations/pet_life_correct.json',
    });
    const platformIncorrectAnimation = lottie.loadAnimation({
      container: document.getElementById('platform-incorrect'),
      renderer: 'svg',
      loop: true,
      path: '/assets/practices/pet_life/animations/pet_life_incorrect.json',
    });
    orangeCatGameAnimation.play();
    blackCatGameAnimation.play();
    platformCorrectAnimation.play();
    platformIncorrectAnimation.play();
    platformCorrectAnimation.setSpeed(1.5);
    platformIncorrectAnimation.setSpeed(1.5);
  },
  methods: {
    checkGameOver() {
      if (
        (this.$store.state.petLife.exerciseCompleted && this.$store.state.petLife.currentLives <= 0) ||
        (this.$store.state.petLife.exerciseCompleted && this.$store.state.petLife.currentExercise >= 4)
      ) {
        this.$store.state.petLife.gameCompleted = true;
      } else {
        this.$store.state.petLife.currentExercise += 1;
      }
    },
    clickContinue() {
      sounds.globalButton.play();
      if (this.buttonStatus === 'active') {
        this.answer = null;
        this.$store.state.petLife.explanationStatus = false;
        this.$store.state.petLife.exerciseCompleted = true;
        this.checkGameOver();
        if (!this.$store.state.petLife.gameCompleted) {
          this.$store.state.petLife.exerciseCompleted = false;
        }
        this.$confetti.stop();
        this.render += 1;
        // this.$store.state.petLife.correctStatus = false;
        this.buttonStatus = 'inactive';
        this.$store.state.petLife.answerStatus = false;
      } else {
        console.log('This button is not active.');
      }
    },
    getRandom(arr, n) {
      const result = new Array(n);
      let len = arr.length;
      const taken = new Array(len);
      if (n > len) throw new RangeError('getRandom: more elements taken than available');
      // eslint-disable-next-line
      while (n--) {
        const x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        // eslint-disable-next-line
        taken[x] = --len in taken ? taken[len] : len;
      }
      return result;
    },
    onClickChild(value) {
      if (value) {
        this.$store.state.petLife.playerScore += 300;
        this.answer = true;
        sounds.petLifeCorrect.play();
        sounds.petLifeCatOrange.play();
        setTimeout(() => {
          this.buttonStatus = 'active';
        }, 2000);
        this.$confetti.start({
          defaultSize: 10,
          particlesPerFrame: 0.15,
          particles: [
            {
              type: 'rect',
            },
            {
              type: 'circle',
            },
            {
              type: 'image',
              size: 70,
              url: '/assets/practices/global/confetti/correct_cool.svg',
            },
          ],
        });
      } else {
        this.$store.state.petLife.currentLives -= 1;
        this.answer = false;
        sounds.petLifeIncorrect.play();
        sounds.petLifeCatBlack.play();
        setTimeout(() => {
          this.$store.state.petLife.explanationStatus = true;
          this.buttonStatus = 'active';
        }, 2000);
        this.$confetti.start({
          defaultSize: 10,
          particlesPerFrame: 0.1,
          defaultDropRate: 10,
          particles: [
            {
              type: 'image',
              size: 20,
              dropRate: 5,
              url: '/assets/practices/global/confetti/incorrect_cross_heavy.svg',
            },
          ],
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.game {
  @include flex-center;
  flex-direction: column;
}

.foreground {
  display: block;
  height: 80vh;
  position: absolute;
  width: 90vw;
}

.bar,
.bar-bottom,
.explanation,
.main {
  @include flex-center;
  box-sizing: border-box;
  width: 85vw;
  z-index: 1;
}

.bar,
.bar-bottom {
  background-color: #77afb1;
  height: 10vh;
  z-index: 2;
}

.bar {
  border-radius: 25px 25px 0 0;
  justify-content: space-between;

  &__points,
  &__lives {
    margin: 0 1vw;
  }

  &__points {
    font-size: 6vh;
    font-family: 'Minecrafter', sans-serif;
    left: 2vw;
    line-height: 0;
  }

  &__lives {
    left: 2vw;

    ul {
      @include flex-center;
      list-style: none;

      li {
        margin: 0 0.5vw;
        @include flex-center;

        .life {
          height: 5.5vh;
        }
      }
    }
  }
}

.bar-bottom {
  border-radius: 0 0 25px 25px;
  justify-content: space-evenly;

  .button--left,
  .button--right {
    transform: translate(0, 8vh);
    width: 25%;
  }

  .buttons--center {
    @include flex-center;
    justify-content: space-around;
    width: 40%;
  }

  .button--right {
    @include flex-center;

    img {
      width: 25vh;
    }

    &--text,
    &--top,
    &--bottom {
      position: absolute;
    }

    &--top {
      @include flex-center;
      z-index: 1;

      img {
        width: 24.25vh;
      }

      &:active {
        transform: translate(0, 8%);
      }
    }

    &--text {
      color: $pet-life-color-main;
      font-family: 'VCR OSD Mono', sans-serif;
      font-size: 150%;
      z-index: 2;

      cursor: pointer;
    }

    &--bottom {
      transform: translate(0, 31%);
    }
  }
}

.main {
  background-color: #d3edef;
  // font-family: 'Rimouski', sans-serif;
  min-height: 45vh;
  position: relative;

  &__question {
    position: absolute;
    text-align: center;
    width: 60%;
  }
}

.explanation {
  background-color: #000000dd;
  border-radius: 25px;
  color: $pet-life-color-main;
  min-height: 65vh;
  position: absolute;

  p {
    text-align: center;
    width: 60%;
  }
}

.feedback__correct,
.feedback__incorrect {
  align-items: center;
  bottom: -8.5vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: absolute;
}

.feedback__correct {
  left: 1vw;
}

.feedback__incorrect {
  right: 1vw;
}

.rise {
  animation: rise 1s forwards;
}

#orange-cat-game,
#black-cat-game {
  height: 18vh;
  margin: 0 1vw;
  width: 26vh;
  z-index: 1;
}

#orange-cat-game {
  transform: translate(-1vh, 0);
}

#black-cat-game {
  transform: translate(2.5vh, 0);
}

#platform-correct,
#platform-incorrect {
  height: 10vh;
  margin: -1vh;
  width: calc(10vh * 4);
}

// #platform-correct {
//   right: 10vh;
// }

// #platform-incorrect {
//   left: 0;
// }

@keyframes rise {
  0% {
    bottom: -8.5vh;
  }
  100% {
    bottom: 0vh;
  }
}

@media (max-aspect-ratio: 8/5) {
  #orange-cat-game,
  #black-cat-game {
    height: 14vh;
    width: calc(14vh * 1.44);
  }

  #orange-cat-game {
    transform: translate(-5vh, 0);
  }

  #black-cat-game {
    transform: translate(6vh, 0);
  }

  .button-left,
  .button--right {
    &--text {
      transform: translate(0, -5%);
    }
  }
}
</style>
